import React from "react"
import styles from './About.module.scss'
import SText from "../../../components/SText";
import Colors from "../../../components/utils/Colors";
import { NavLink } from "react-router-dom";
import { colorToFilter } from "../../../components/utils/ColorFilter";
import back from "../../../assets/images/cart/goBack.svg";

const About = () => {

    return <div className={ styles.wrapper }>
        <div className={ styles.header }>
            <NavLink to={ '/' }>
                <div className={ styles.goBack }><img style={ { filter: colorToFilter('#383838') } } src={ back } /></div>
            </NavLink>
            <div><SText size={ 26 } lineHeight={ 20 } weight={ 700 } color={ Colors.black }>{ 'О нас' }</SText></div>
        </div>
        <div className={ styles.container }>
            <div style={ { marginBottom: 16 } }>
                <SText size={ 16 } lineHeight={ 20 }>{ 'MoscowFresh — это удобная доставка полезных и вкусных продуктов отборного качества. На MoscowFresh представлен полный ассортимент наиболее качественных товаров от фермерских молочных продуктов и домашнего мяса до привезенных самолётом фруктов и охлаждённой рыбы. По каждому заказу мы сами выбираем самые свежие продукты, полученные от проверенных продавцов, аккуратно их упаковываем и доставляем в удобное время в точный часовой интервал.' }</SText>
            </div>



        </div>
    </div>
}

export default About